import { ACTIONS } from 'redux-api-call';
import { combineEpics, ofType } from 'redux-observable';
import { eq, flow, get } from 'lodash/fp';
import { filter, map } from 'rxjs/operators';

import { CREATE_TOPUP_RECORD_API_ID } from '../../apiCalls/adminTopups/create';
import routerHistory from '../../routerHistory';

const handleCreateTopupRecordSuccess = actions$ =>
  actions$.pipe(
    ofType(ACTIONS.COMPLETE),
    filter(flow(get('payload.name'), eq(CREATE_TOPUP_RECORD_API_ID))),
    map(() => {
      routerHistory.goBack();
    })
  );

export default combineEpics(handleCreateTopupRecordSuccess);
